// lodash
import get from 'lodash/get';
import find from 'lodash/find';

import {
  GET_FEATURES,
  GET_PAYMENT_PAGE,
  HAND_OVER,
  INIT_PAYMENT_PAGE,
  REDUX_HYDRATE,
  UPDATE_FEATURE,
} from '../../../constants/actionConstants';
import featureConstants from '../../../constants/featureConstants';
import unionWithDevFeatures from '../../../utils/features/feature-utils';

export function setFeatureOverrideCookie(features) {
  const value = features.map(({ id, enabled }) => `${id}:${enabled}`);
  document.cookie = `feature_override_cookie=${value.toString()}`;
}

export const isFeatureActive = (state, featureId, defaultValue = false) => {
  const features = get(state, 'config.features', []);
  const feature = find(features, feature => feature.id === featureId);
  if (feature) {
    return feature.enabled === true;
  }

  return defaultValue;
};


export const INITIAL_STATE = {
  applePayOptions: {},
  content: {},
  countries: [],
  features: [],
  creditCardTypePatterns: [],
  applePayConfiguration: {},
  frontendKeys: {
    googleMapsApiKey: '',
    loqateApiKey: '',
  },
};
export default function configReducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case REDUX_HYDRATE: {
      const persistedAuth0ClientConfiguration = get(action.payload, 'config.auth0ClientConfiguration');

      // Bit of a short-term hack to allow utility functions in isAddressValid.js to know whether the
      // TITLE_DROPDOWN_ENABLED is enabled, as this cannot be easily passed through the reducers as
      // they're sometimes provided by the jl-design-system.
      const titleDropdownFeatureEnabled = isFeatureActive({ config: { features: state.features } },
        featureConstants.TITLE_DROPDOWN_ENABLED);

      window.title_dropdown_enabled = titleDropdownFeatureEnabled;

      return {
        ...state,
        auth0ClientConfiguration: persistedAuth0ClientConfiguration,
      };
    }

    case UPDATE_FEATURE: {
      const features = state.features.map((feature) => {
        if (action.id === feature.id) {
          // Bit of a short-term hack to allow utility functions in isAddressValid.js to know whether the
          // TITLE_DROPDOWN_ENABLED is enabled, as this cannot be easily passed through the reducers as
          // they're sometimes provided by the jl-design-system.
          if (feature.id === featureConstants.TITLE_DROPDOWN_ENABLED) {
            window[feature.id] = action.enabled;
          }
          return { ...feature, enabled: action.enabled };
        }
        return feature;
      });

      setFeatureOverrideCookie(features);

      return {
        ...state,
        features,
      };
    }

    case `${GET_PAYMENT_PAGE}.SUCCESS`:
    case `${INIT_PAYMENT_PAGE}.SUCCESS`: {
      const applePayOptions = get(action, 'result.applePayOptions');

      return {
        ...state,
        applePayOptions,
      };
    }

    case `${GET_FEATURES}.SUCCESS`: {
      const bffFeatures = get(action.result, 'features', []);
      const features = unionWithDevFeatures(bffFeatures);

      const updatedState = {
        ...state,
        features,
      };

      // Bit of a short-term hack to allow utility functions in isAddressValid.js to know whether the
      // TITLE_DROPDOWN_ENABLED is enabled, as this cannot be easily passed through the reducers as
      // they're sometimes provided by the jl-design-system.
      const titleDropdownFeatureEnabled = isFeatureActive({ config: { features: updatedState.features } },
        featureConstants.TITLE_DROPDOWN_ENABLED);

      window.title_dropdown_enabled = titleDropdownFeatureEnabled;

      return updatedState;
    }

    case `${HAND_OVER}.SUCCESS`: {
      const auth0ClientConfiguration = get(action.result, 'auth0ClientConfiguration');
      return {
        ...state,
        auth0ClientConfiguration,
      };
    }

    default:
      return state;
  }
}
